export const INPUT_TYPES = [
  { label: 'Texto', value: 'text' },
  { label: 'Seleção', value: 'select' },
  { label: 'Área de Texto', value: 'textarea' },
  { label: 'Data', value: 'date' },
  { label: 'Hora', value: 'time' },
  { label: 'Campo de Check', value: 'checkbox' },
];
